import { create, v } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/framework/core/middleware/theme';
import { Keys } from '@holmescorp/common';
import { keymap, pathmap } from '@holmescorp/lcc-state';
import { numeral } from '@holmescorp/numeral';
import css from '../css/topicgroup.m.css';
const factory = create({ theme }).properties();
export const DiscussionButton = factory(({ properties, middleware: { theme } }) => {
    const themeCss = theme.classes(css);
    const { topicid, text } = properties();
    const icon = `${window.hcstatic.portal_cdn}/js/images/iconsheet.svg#quiz`;
    const discussionScore = '';
    return v('div', {
        classes: [themeCss.action],
        xqa: 'discussion-action-button',
        tabIndex: 0,
        onclick: (event) => {
            event && event.stopPropagation();
            const { path } = keymap.get(topicid);
            const { view } = pathmap.get(`${path}/discussion`);
            view();
        },
        onkeydown: (event) => {
            const { path } = keymap.get(topicid);
            const { view } = pathmap.get(`${path}/discussion`);
            switch (event.key) {
                case Keys.Enter:
                case Keys.Space:
                case Keys.Spacebar:
                    event.preventDefault();
                    view();
            }
        }
    }, [
        v('svg', { classes: [themeCss.actionIcon], 'xmlns:xlink': 'http://www.w3.org/1999/xlink' }, [
            v('use', {
                href: icon,
                'xlink:href': icon
            })
        ]),
        discussionScore
            ? v('div', { classes: [themeCss.scorePill] }, [
                v('span', { classes: [themeCss.scoreLabel] }, [`${numeral(discussionScore).format('0%')}`])
            ])
            : null,
        v('div', { classes: [themeCss.actionText] }, [text])
    ]);
});
